import baseUrl from '../../../utils/baseUrl';
import getToken from '../../../utils/getToken';

export default async function addUserProfileV1(category, nickname, dataUrl) {
  async function addUserProfile(category, nickname, dataUrl) {
    return fetch(`${baseUrl()}/api/v1/user_profiles`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`
      },
      body: JSON.stringify({
        user_profile: {
          category: category,
          nickname: nickname,
          data_url: dataUrl
        }
      })
    });
  }

  return addUserProfile(category, nickname, dataUrl);
}
